var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevicePowerCut01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_142_00000029038309575336343570000010241014778217228675_",
    d: "M50.3,460.7l185.1-296.5H133.5l65.9-131.8H70.9L16,263 h85.1L50.3,460.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M401.9,358.9l90.2-90.2c2.5-2.5,3.9-5.8,3.9-9.3c0-3.5-1.4-6.9-3.9-9.3l-7.9-7.9c-2.5-2.5-5.8-3.9-9.3-3.9 c-3.5,0-6.8,1.4-9.3,3.9l-90.2,90.2l-90.2-90.2c-2.5-2.5-5.8-3.9-9.3-3.9c-3.5,0-6.8,1.4-9.3,3.9l-7.9,7.9 c-5.1,5.1-5.1,13.5,0,18.7l90.2,90.2l-90.2,90.2c-2.5,2.5-3.9,5.8-3.9,9.3c0,3.5,1.4,6.8,3.9,9.3l7.9,7.9 c2.5,2.5,5.8,3.9,9.3,3.9c3.5,0,6.8-1.4,9.3-3.9l90.2-90.2l90.2,90.2c2.5,2.5,5.8,3.9,9.3,3.9h0c3.5,0,6.8-1.4,9.3-3.9l7.9-7.9 c2.5-2.5,3.9-5.8,3.9-9.3c0-3.5-1.4-6.8-3.9-9.3L401.9,358.9z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicePowerCut01);
export default __webpack_public_path__ + "static/media/devicePowerCut-01.da24893890c4d37f131bafc056024c77.svg";
export { ForwardRef as ReactComponent };